import React from 'react'
import "./Electrical.css"
import Slider from '../../Home/Slider/Slider'
import electrical1 from "../Departmentimage/IMG_1272 (FILEminimizer).JPG"
const Electrical = () => {
  return (
    <div className='main-container-electrical'>
      {/* <Slider></Slider> */}
     
     <div className='container-electrical'>
     <div data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
      <h1>ELECTRICAL ENGINEERING</h1> <hr />
      </div>
  
<div data-aos="fade-up"
     data-aos-duration="3000">

      <div className='electrical5'>
      <div className='electrical4'>
      <div className='electrical3'>
      <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">

        <div className='electrical'>

            <p>
            The need of technical manpower in the area of Electrical Energy in respect of its generation, transmission, distribution and control and also in respect of design and manufacturing of 
            equipment for above activities has always been recognized. The College has embarked upon this programme in Electrical and Electronics Engineering Department keeping in view 
            the above requirement. The Lab facilities in basic Electronics and Electrical Technology are available.
            </p> <br /> 
            <p>
            Transistor in common base & emitter, VI characteristics of a photo voltaic cell, Study of MOSFET/JFET, Plot Thyrister characteristics UIT, Diac & Triac. Study of loss factor in a 
            dielectric by an impedance bridge, Study of photo resist in metal pattern for planner technology/PCB technology.
            </p>
            <p>
        The following Laboratories are existing in the department.
        </p> <br />
        <ul>
          <li>FEE Lab</li>
          <li>Electrical Measurements & Measuring Instruments Lab</li>
          <li>Electronic Devices & Circuit</li>
          <li> Power Electronics Lab</li>
          <li> Electrical Machine Lab</li>
        </ul>
        </div>
        </div>
        <div data-aos="flip-left"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000">
      <div className='electrical-image'>
        <img src={electrical1}   className='electrical1'/>
      </div>
      </div>
     </div>
    </div>
    </div>
  </div>
  </div>
  </div>   
  )
}

export default Electrical
